/**
 * @generated SignedSource<<98a69d6b556c1af8a86d66c13e4614b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EquipmentCategory = "AUDIO_VIDEO" | "BATTERY" | "CABLE" | "CAMERA" | "CAMERA_ACCESSORY" | "ETC" | "KIT" | "LENS" | "LIGHTING" | "MEDIA" | "NETWORK" | "POWER" | "PRINTER" | "SECURITY" | "WORKSTATION" | "WORKSTATION_ACCESSORY" | "%future added value";
export type ReservationStatus = "CANCELLED" | "CHECKED_OUT" | "CONFIRMED" | "DRAFT" | "PICKED" | "REQUESTED" | "RETURNED" | "%future added value";
export type ClientReservationPageQuery$variables = {
  id: string;
};
export type ClientReservationPageQuery$data = {
  readonly myReservation: {
    readonly customerCancellable: boolean;
    readonly days: number;
    readonly endsAt: any;
    readonly id: string;
    readonly lines: ReadonlyArray<{
      readonly asset: {
        readonly assetTag: any;
        readonly category: EquipmentCategory;
        readonly dailyRate: any | null | undefined;
        readonly kitMembers: ReadonlyArray<{
          readonly id: string;
        }>;
        readonly name: string;
      };
      readonly id: string;
    }>;
    readonly notes: string | null | undefined;
    readonly quotedTotal: any | null | undefined;
    readonly startsAt: any;
    readonly status: ReservationStatus;
  } | null | undefined;
  readonly viewer: {
    readonly id: string;
  } | null | undefined;
};
export type ClientReservationPageQuery = {
  response: ClientReservationPageQuery$data;
  variables: ClientReservationPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startsAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endsAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "days",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quotedTotal",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerCancellable",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetTag",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "kitMembers",
  "plural": true,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dailyRate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientReservationPageQuery",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Reservation",
        "kind": "LinkedField",
        "name": "myReservation",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ReservationLine",
            "kind": "LinkedField",
            "name": "lines",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Asset",
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientReservationPageQuery",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Reservation",
        "kind": "LinkedField",
        "name": "myReservation",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ReservationLine",
            "kind": "LinkedField",
            "name": "lines",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Asset",
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d3d31efb9f217ef8c0c4febeea5a1a15",
    "id": null,
    "metadata": {},
    "name": "ClientReservationPageQuery",
    "operationKind": "query",
    "text": "query ClientReservationPageQuery(\n  $id: ID!\n) {\n  viewer {\n    id\n  }\n  myReservation(id: $id) {\n    id\n    status\n    startsAt\n    endsAt\n    days\n    notes\n    quotedTotal\n    customerCancellable\n    lines {\n      id\n      asset {\n        assetTag\n        name\n        category\n        kitMembers {\n          id\n        }\n        dailyRate\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0de1baed1e1ea86b0d50b2b9d5682317";

export default node;
